import { DELIVERY_ORDER_TYPE, ROUTE_CHECKOUT } from '../constants';
import { brazeLogCustomEventCheckoutStarted } from '../helpers/brazeHelper';
import type { CheckoutStartedOrderAmount } from '../helpers/brazeHelper';
import { persistZero, roundNumber } from '../helpers/helperMethods';
import store from '../redux/store/store';
import {
  disarmCheckoutStarted,
  isCheckoutStartedPending,
} from './pulseCheckoutId';
import { trackStartCheckout } from './pulseCheckoutStarted';

const isCheckoutPath = (): boolean =>
  typeof window !== 'undefined' &&
  window.location.pathname.includes(ROUTE_CHECKOUT);

const isMobileWeb = (): boolean =>
  typeof window !== 'undefined' &&
  window.matchMedia('(max-width: 767px)').matches;

export const buildCheckoutStartedOrderAmountFromCart = (
  cart: any
): CheckoutStartedOrderAmount => {
  const deliveryFee = cart?.free_delivery ? 0 : Number(cart?.delivery_fee ?? 0);
  const serviceFee = cart?.free_delivery ? 0 : Number(cart?.service_fee ?? 0);
  let total = Number(cart?.net_sales ?? 0) + Number(cart?.tax ?? 0);
  if (cart?.orderType === DELIVERY_ORDER_TYPE) {
    total += deliveryFee + serviceFee;
  }
  return {
    discount: cart?.discount ?? 0,
    tax: cart?.tax ?? 0,
    subTotal: cart?.gross_sales ?? 0,
    total: Number(persistZero(roundNumber(total, 2))),
  };
};

/** Fire Braze + Pulse checkout_started once when pending, on checkout after cart sync. */
export const fireCheckoutStartedIfPending = (): void => {
  try {
    if (!isCheckoutPath()) return;
    if (!isCheckoutStartedPending()) return;

    const cart = store.getState().cart;
    const orderAmount = buildCheckoutStartedOrderAmountFromCart(cart);
    const slotDetails = cart?.orderDetails?.PickupSlotDetails;
    const isItMobile = isMobileWeb();
    const pagePath = window.location.pathname;

    void brazeLogCustomEventCheckoutStarted(
      cart,
      orderAmount,
      isItMobile,
      slotDetails
    );
    trackStartCheckout(cart, orderAmount, isItMobile, slotDetails, pagePath);
    disarmCheckoutStarted();
  } catch (_) {
    // Tracking must never affect product flow.
  }
};
